export default (context) => {
  const { app, $gtm, error } = context;
  if (app.$storeConfig.error === 'no_shop_find') {
    return error({ statusCode: 403, message: 'Domain not found' })
  }
};
